// src/utils/http.js
import router from '@/router'
import { Message } from 'element-ui'

const BASE_URL = '/api'

async function request(url, options = {}) {
  // 从localStorage获取token
  const token = localStorage.getItem('token');
  
  console.log('Token from localStorage:', token); // 调试:查看token值
  
  // 处理GET请求的params参数
  let fullUrl = `${BASE_URL}${url}`
  if (options.method === 'GET' && options.params) {
    const queryString = new URLSearchParams(options.params).toString()
    if (queryString) {
      fullUrl += `?${queryString}`
    }
  }
  
  console.log('Request URL:', fullUrl); // 添加日志进行排查
  
  // 如果存在有效的token,则添加到请求头
  // 根据后端配置 admin-token-name: Authorization,直接传递token值
  let authToken = null;
  if (token && token !== '' && token !== 'null' && token !== 'undefined') {
    authToken = token;
    console.log('Authorization header:', authToken); // 调试:查看请求头
  }
  
  // 构建请求头 - 确保Authorization不会被options.headers覆盖
  const headers = {
    'Content-Type': 'application/json',
    ...(authToken && { 'Authorization': authToken }), // 先设置Authorization
    ...options.headers  // 然后允许options.headers覆盖其他头,但不会覆盖Authorization(因为后面会再次设置)
  }
  
  // 再次确保Authorization正确设置(防止被options.headers覆盖)
  if (authToken) {
    headers['Authorization'] = authToken;
  }

  const config = {
    headers: headers,
    ...options
  }
  
  // 修复：确保 options.headers 不会覆盖已合并好的 headers（包含 Authorization）
  config.headers = headers
  
  // 删除config中的params属性，避免传递给fetch
  delete config.params

  const response = await fetch(fullUrl, config)

  console.log('Response status:', response.status); // 调试:查看响应状态码
  
  // 检查是否是401未授权状态
  if (response.status === 401) {
    console.error('❌ 收到401响应 - Token验证失败');
    console.error('📍 请求URL:', fullUrl);
    console.error('🔑 Token长度:', token ? token.length : 0);
    console.error('🔑 Token前30字符:', token ? token.substring(0, 30) + '...' : 'null');
    console.error('📤 请求方法:', options.method || 'GET');
    
    // 尝试读取响应体获取更多信息
    try {
      const errorBody = await response.clone().text();
      console.error('📥 401响应体:', errorBody);
      
      // 解析错误信息
      try {
        const errorJson = JSON.parse(errorBody);
        console.error('错误代码:', errorJson.code);
        console.error('错误消息:', errorJson.msg);
      } catch (e) {
        // 忽略解析错误
      }
    } catch (e) {
      console.error('无法读取401响应体');
    }
    
    // 清除本地存储的token
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('username');
    // 显示登录过期提示
    Message.error('Token验证失败,请重新登录');
    // 跳转到登录页面
    router.push('/login');
    // 返回特殊标记，不抛出错误（避免调用方重复提示）
    return { code: 401, msg: 'Token验证失败' };
  }

  try {
    const result = await response.json()
    
    // 根据新的返回格式处理响应
    if (result.code === 200) {
      return result;
    } else {
      // 当code不为200时，抛出错误，错误信息为msg字段
      throw new Error(result.msg || `Request failed with code: ${result.code}`)
    }
  } catch (e) {
    if (e instanceof SyntaxError) {
      // JSON解析失败的处理
      const text = await response.text()
      throw new Error(`Invalid JSON response: ${text}`)
    }
    // 重新抛出已知的错误（如业务逻辑错误）
    throw e
  }
}

export async function get(url, params = {}) {
  const queryString = new URLSearchParams(params).toString()
  const fullUrl = queryString ? `${url}?${queryString}` : url
  return request(fullUrl, { method: 'GET' })
}

export async function post(url, data = {}, params = {}) {
  const queryString = new URLSearchParams(params).toString()
  const fullUrl = queryString ? `${url}?${queryString}` : url
  return request(fullUrl, {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

export async function put(url, data = {}) {
  return request(url, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

export async function del(url) {
  return request(url, { method: 'DELETE' })
}

// 文件上传函数
export async function upload(file, path = '') {
  const formData = new FormData()
  formData.append('image', file)
  
  if (path) {
    formData.append('path', path)
  }
  
  try {
    const response = await fetch(`${BASE_URL}/common/upload`, {
      method: 'POST',
      body: formData
    })
    
    const result = await response.json()
    
    if (result.code === 200) {
      return result
    } else {
      throw new Error(result.msg || '上传失败')
    }
  } catch (error) {
    throw new Error('图片上传失败: ' + (error.message || ''))
  }
}

// 导出BASE_URL以供el-upload的action属性使用
export { BASE_URL }

// 导出通用request函数以供特殊需求使用
export { request }